import { motion } from 'framer-motion';
import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';

function FloatingContactWidget() {
  const contactInfo = {
    phone: '+8801709919827',
    whatsapp: '+8801709919827',
    email: 'booking@chutipurbachal.com'
  };

  const contactButtons = [
    {
      id: 'phone',
      icon: FaPhone,
      label: 'Phone Call',
      color: 'from-blue-500 to-blue-600',
      hoverColor: 'hover:from-blue-600 hover:to-blue-700',
      link: `tel:${contactInfo.phone}`,
      delay: 0.1
    },
    {
      id: 'whatsapp',
      icon: FaWhatsapp,
      label: 'WhatsApp',
      color: 'from-green-500 to-green-600',
      hoverColor: 'hover:from-green-600 hover:to-green-700',
      link: `https://wa.me/${contactInfo.whatsapp}`,
      delay: 0.2
    },
    {
      id: 'email',
      icon: FaEnvelope,
      label: 'Email',
      color: 'from-red-500 to-red-600',
      hoverColor: 'hover:from-red-600 hover:to-red-700',
      link: `mailto:${contactInfo.email}`,
      delay: 0.3
    }
  ];

  return (
    <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex flex-col gap-2 md:gap-3">
      {contactButtons.map((button) => (
        <motion.a
          key={button.id}
          href={button.link}
          target={button.id === 'whatsapp' || button.id === 'email' ? '_blank' : undefined}
          rel={button.id === 'whatsapp' || button.id === 'email' ? 'noopener noreferrer' : undefined}
          initial={{ x: 100, opacity: 0, scale: 0 }}
          animate={{ x: 0, opacity: 1, scale: 1 }}
          transition={{ 
            delay: button.delay, 
            type: 'spring', 
            stiffness: 200,
            damping: 15
          }}
          whileHover={{ 
            scale: 1.15,
            rotateZ: 5,
          }}
          whileTap={{ scale: 0.9 }}
          className={`
            group relative
            w-12 h-12 md:w-14 md:h-14
            bg-gradient-to-br ${button.color} ${button.hoverColor}
            text-white
            rounded-full
            shadow-lg hover:shadow-2xl
            transition-all duration-300
            cursor-pointer
            transform-gpu
            flex items-center justify-center
          `}
          style={{
            transformStyle: 'preserve-3d',
          }}
          title={button.label}
        >
          {/* 3D Icon Container */}
          <motion.div
            className="relative z-10"
            whileHover={{ 
              rotateY: 360,
            }}
            transition={{ duration: 0.6 }}
          >
            <button.icon className="text-lg md:text-xl" />
          </motion.div>

          {/* Glow effect */}
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-30 rounded-full blur-md transition-opacity duration-300" />

          {/* Pulse animation */}
          <motion.div
            className={`absolute inset-0 bg-gradient-to-br ${button.color} rounded-full opacity-75`}
            animate={{
              scale: [1, 1.3, 1],
              opacity: [0.5, 0, 0.5]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeOut",
              delay: button.delay
            }}
          />

          {/* 3D Shadow effect */}
          <div 
            className="absolute inset-0 bg-black opacity-20 rounded-full blur-sm -z-10"
            style={{ transform: 'translateZ(-8px)' }}
          />
        </motion.a>
      ))}

      {/* Floating particles effect */}
      {[...Array(3)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-1.5 h-1.5 md:w-2 md:h-2 bg-teal-400 rounded-full pointer-events-none"
          initial={{ 
            x: 0, 
            y: 0, 
            opacity: 0.6,
            scale: 0 
          }}
          animate={{
            x: [0, Math.random() * 40 - 20],
            y: [0, -Math.random() * 60 - 30],
            opacity: [0.6, 0],
            scale: [0, 1, 0]
          }}
          transition={{
            duration: 1.8,
            repeat: Infinity,
            delay: i * 0.4,
            ease: "easeOut"
          }}
          style={{
            bottom: '25%',
            right: '30%'
          }}
        />
      ))}
    </div>
  );
}

export default FloatingContactWidget;

